export default __webpack_public_path__ + "static/media/report-analytics-reports.25c54a44.png";